// extracted by mini-css-extract-plugin
export var filterIncDec = "_4p-0";
export var leftBorder = "_4p-1";
export var rightBorder = "_4p-2";
export var stringInput = "_4p-3";